
























































































































import { Component, Mixins, Prop, Watch, Emit } from 'vue-property-decorator';
import { RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper } from '../../../core/mixins';
import Axios from 'axios';
import { TrackingService } from '../../../core/api';
import DeleteConfirmation from '../Geofences/DeleteConfirmation.vue';
import {
    DataVisualization,
    Filter,
    HistoricalVisualizationResponse,
    Marker,
    Visualization
} from '../../../core/models';

import * as chroma from 'chroma-js';
import { hasElements, LegendMap, Method, VisualizationApply } from '../../../core/utils';
import { getNumberByPaintingType, PaintingType } from '../../utils';
import Input from '../../../core/components/Input.vue'; 
@Component({
    components: {
        DeleteConfirmation,
        Input
    }
})
export default class FilterQuickAccess extends Mixins(RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper) {
    @Prop({ default: () => () => [] }) filters: Filter[];
    @Prop({ default: () => () => [] }) allVariables: object;
    @Prop() removeFilters: Method<string[], void>;
    @Prop({ default: false }) disable: boolean;
    @Prop({ default: false }) show: boolean;
    @Prop() applyVisualization: Method<VisualizationApply | null, Promise<HistoricalVisualizationResponse>>;
    @Prop() updateMarkersHistoricalFromVisualizationApply: Method<Marker[], void>;
    visualizationApplied: Visualization | null = null;

    menu: boolean = false;
    message: boolean = false;
    searchField: string | null = null;
    searchedFilters: Filter[] = [];
    loadingVisualization: boolean = false;
    confirmationDelete: boolean = false;
    filterToDelete: Filter | null = null;
    addingOrEditing: boolean = false;
    
    updateSearchField(value){
        this.searchField = value;
    }

    @Emit()
    showAddFilter(filter: Filter | null, isFilterSelected: boolean) {
        this.addingOrEditing = true;
        return { filter: filter, isFilterSelected: isFilterSelected };
    }

    @Emit()
    setLoadingTravel(value) {
        return value;
    }

    @Watch('menu')
    enableOrDisableGlobalKeyListener() {
        if (this.menu) {
            this.addingOrEditing = false;
            this.$_disableListenkey();
        } else {
            if (!this.addingOrEditing) {
                this.$_enableListenkey();
            }
        }
    }

    get getGTMBtnCustomFilter() {
        return !this.$store.state.userGroupSmartway ? 'ga_btn_tracking_show_custom_filter' : '';
    }

    mounted() {
        this.searchedFilters = this.filters;
    }

    @Watch('filters')
    updateFilters() {
        this.searchedFilters = this.filters;
    }

    @Watch('searchField')
    searchChange() {
        if (this.searchField) {
            this.searchedFilters = this.filters.filter(filter =>
                this.filterHandler(filter, this.searchField as string)
            );
        } else {
            this.searchedFilters = this.filters;
        }
    }

    filterHandler(filter: Filter, queryText: string): boolean {
        let queryTextLowerCase = queryText.toLocaleLowerCase();
        return filter.name
            .toString()
            .toLocaleLowerCase()
            .includes(queryTextLowerCase);
    }

    checkIfNeedToShowSampledAlert = (response: HistoricalVisualizationResponse | null) => {
        if(response && response.sample_rate && response.sample_rate !== null){
            this.$_showAddPointOfInterest(
                'Se está visualizando un muestreo en el filtro.<br> Se están visualizando el ' + response.sample_rate + '% de las posiciones'
            );
        }
    }

    handleApplyVisualization(idFilterActive: string | null, visualization: Visualization | null): void {
        let self = this;
        this.loadingVisualization = true;
        if (visualization && idFilterActive) {
            this.applyVisualization({
                filterId: idFilterActive,
                visualizationId: visualization.id
            })
                .then((result: HistoricalVisualizationResponse | null) => {
                    
                    
                    if (result && hasElements(result.tracking)) {
                        this.updateMarkersHistoricalFromVisualizationApply(this.buildMarkers(result, visualization));
                        
                        this.loadingVisualization = false;
                        setTimeout(() => {
                            self.checkIfNeedToShowSampledAlert(result)
                        }, 0);
                    } else {
                        this.applyVisualization(null);
                        this.visualizationApplied = null;
                        this.$_showEmptyApplyVisualization('La visualización seleccionada no contiene información');
                        this.loadingVisualization = false;
                    }
                    this.setLoadingTravel(false);
                })
                .catch(error => {
                    this.$_errorApplyVisualization(error.response.data.message || error.message);
                    this.applyVisualization(null);
                    this.visualizationApplied = null;
                    this.loadingVisualization = false;
                    this.setLoadingTravel(false);
                });
        } else {
            this.applyVisualization(null);
            this.visualizationApplied = null;
            this.loadingVisualization = false;
        }
    }

    handleDeleteFilter(filter) {
        this.confirmationDelete = true;
        this.filterToDelete = filter;
    }

    deleteFilter(action: boolean) {
        this.confirmationDelete = false;
        if (action) {
            if (this.filterToDelete) {
                const token = Axios.CancelToken.source();
                TrackingService.deleteFilterById([this.filterToDelete.id], token)
                    .then(response => {
                        if (response['status'] === 200 || response['status'] === 204) {
                            if (this.filterToDelete) {
                                this.$_successDeleteFilter('Eliminado correctamente');
                                this.removeFilters([this.filterToDelete.id]);
                                for (let i = 0; i < this.filterToDelete.visualizations.length; i++) {
                                    if (this.visualizationApplied) {
                                        if (this.visualizationApplied.id === this.filterToDelete.visualizations[i].id) {
                                            this.applyVisualization(null);
                                            this.visualizationApplied = null;
                                        }
                                    }
                                }
                            }
                        }
                    })
                    .catch(error => {
                        this.$_errorAddFilter('Error al eliminar');
                    });
            }
        }
    }

    updateVisualizationApplied() {
        if (this.visualizationApplied !== null) {
            this.setLoadingTravel(true);
            this.handleApplyVisualization(this.visualizationApplied['id_filter'], this.visualizationApplied);
        }
    }

    getUnitByVariableKey(variableKey: string): string {
        let unit = '';
        if (this.allVariables[variableKey]) {
            unit = this.allVariables[variableKey].unit
        }
        return unit;
    }

    getDescriptionByVariableKey(variableKey: string): string {
        let description = '';
        if (this.allVariables[variableKey]) {
            description = this.allVariables[variableKey].description
        }
        return description;
    }

    buildMarkers(response: HistoricalVisualizationResponse, visualization: Visualization): Marker[] {
        this.$_setLegend(null);
        let markers: Marker[] = [];
        const colors = this.getTones(visualization);
        const intervals = this.getIntervals(visualization);
        for (let i = 0; i < response.tracking.length; i++) {
            const datas: DataVisualization[] = response.tracking[i].data;
            const id: number = response.tracking[i].vehicle_id;

            for (let j = 0; j < datas.length; j++) {
                const data = datas[j];
                const variableKey = data.variable_key;
                const variableUnit = this.getUnitByVariableKey(variableKey);
                const variableDescription = this.getDescriptionByVariableKey(variableKey);

                // console.log("data", data);

                markers.push({
                    lat: data.latitude,
                    lng: data.longitude,
                    icon: {
                        rotation: data.course,
                        path: ''
                    },
                    info: this.$_getVehiclesMap[id],
                    
                    infoState: {
                        variable_key: variableKey,
                        variable_description: variableDescription,
                        variable_unit: variableUnit,
                        speed: 0,
                        color: this.calculeColor(
                            datas[j].value as number,
                            intervals,
                            colors,
                            visualization.min,
                            visualization.max
                        ),
                        timestamp: data.timestamp,
                        state: `${data.vehicle_state}`,
                        metters: visualization.working_width,
                        work_order_dest: null,
                        work_order_mount: null,
                        work_order_number: null,
                        work_order_unload_date: null,
                        vehicle_type: 0,
                        vehicle_state: {},
                        work_order_load_state: 0,
                        value: datas[j].value as number
                    }
                });
            }
        }
        this.$_setLegend(
            this.getLegend(
                colors,
                intervals,
                visualization.max,
                visualization.variable.unit ? visualization.variable.unit : ''
            )
        );

        return markers;
    }

    getTones(visualization: Visualization): string[] {
        let sourceColor;
        let targetColor;
        if (visualization.painting_type === getNumberByPaintingType(PaintingType.RED_GREEN)) {
            sourceColor = 'red';
            targetColor = 'green';
        } else {
            sourceColor = 'green';
            targetColor = 'red';
        }
        return chroma.scale([sourceColor, '#ffff00', targetColor]).colors(visualization.tone_quantity);
    }

    getIntervals(visualization: Visualization): number[] {
        const interval: number[] = [];
        const rest = visualization.max - visualization.min;
        const partition = rest / visualization.tone_quantity;
        let count = visualization.min;
        for (let i = 0; i < visualization.tone_quantity; i++) {
            interval.push(count);
            count = count + partition;
        }
        return interval;
    }

    getLegend(colors: string[], intervals: number[], max: number, unit: string): LegendMap {
        let result: LegendMap = {};
        for (let i = 0; i < intervals.length; i++) {
            if (i === intervals.length - 1) {
                result = { 
                    ...result, 
                    [`${this.round(intervals[i])} - ` + ` ${this.round(max)} ${unit} `]: {
                        color: colors[i],
                        styles: {}
                    } 
                };
            } else {
                result = {
                    ...result,
                    [`${this.round(intervals[i])} - ` + ` ${this.round(intervals[i + 1])} ${unit}`]: {
                        color: colors[i],
                        styles: {},
                    } 
                };
            }
        }
        return result;
    }

    round(num: number): number {
        return Math.round(num * 100) / 100;
    }

    calculeColor(value: number, interval: number[], colors: string[], min: number, max: number): string {
        let color: string = 'black';
        if (value < min || value > max) {
            return color;
        }
        for (let i = interval.length - 1; i >= 0; i--) {
            if (value >= interval[i]) {
                color = colors[i];
                break;
            }
        }
        return color;
    }

    isVisualizationApplied(visualization: Visualization): boolean {
        if (this.visualizationApplied === null) {
            return false;
        } else {
            return this.visualizationApplied.id === visualization.id;
        }
    }

    handleChange(change: any, id: string, visualization: Visualization): void {
        if (change) {
            visualization['id_filter'] = id;
            this.visualizationApplied = visualization;
            this.handleApplyVisualization(id, visualization);
        } else {
            this.applyVisualization(null);
            this.$_setLegend(null);
            this.visualizationApplied = null;
        }
    }

    open(): void {
        this.menu = true;
    }

    close(): void {
        this.menu = false;
    }
}
